export default {
    CHANGE_SIDE_ITEM: 'CHANGE_SIDE_ITEM',
    CLEAN_UP_ITEM: 'CLEAN_UP_ITEM'
};